import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type RemoveFromCartResponse = { data: { items: { cart: Cart } } };

export const removeFromCart = (materialId: number): Promise<Cart> =>
    (axios.delete(`${API_URLS.CART}remove/${materialId}`) as unknown as Promise<RemoveFromCartResponse>).then(
        (response) => response.data.items.cart
    );
